import { BasicSVG } from "../basicsvg.js";
/**
 * @class MSPolygon
 * @extends BasicSVG
 * @classdesc Полигон
 * */
export class MSPolygon extends BasicSVG {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "bordergeometry",
            "eventcontur",
            "borderticknesshover",
            "bordercolorhover",
        ]);
    }

    constructor() {
        super();
        this._createInnerSVG("path");
        this._path.setAttribute("shape-rendering", "geometricPrecision");
        this._path.setAttribute("vector-effect", "non-scaling-stroke");
        this.borderthickness = 2;
        this._d = "M0,0";
        this._polygonClickHandler = this._handlePolygonContur.bind(this);
        this._path.addEventListener('mouseenter', this._handleMouseEnter.bind(this))
        this._path.addEventListener('mouseleave', this._handleMouseLeave.bind(this))
    }

    // Из-за Bug 20972: Примитивы не отображаются при переключении видимости экземпляра окна, если начальное значение видимости=False
    // функция afterInitialize() закоменчена
    //afterInitialize() {
    //    this._path.setAttribute('d', this._d);
    //    const size = this._path.getBBox();
    //    this._main.setAttribute('viewBox', `${size.x} ${size.y} ${size.width} ${size.height}`);
    //    this._resource && (this.resource = this._resource);
    //}

    get bordercolorhover() {
        return this._bordercolorhover;
    }

    set bordercolorhover(value) {
        this._bordercolorhover = value;
    }

    get borderticknesshover() {
        return this._borderthicknesshover;
    }

    set borderticknesshover(value) {
        this._borderthicknesshover = value;
    }

    get width() {
        return this._width;
    }

    set width(value) {
        this._width = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.width = this._setValueUnit(value);
            this._main.setAttribute("width", this._setValueUnit(value));
        }
    }

    get eventcontur() {
        return this._eventcontur;
    }

    set eventcontur(value) {
        this._eventcontur = value;
        this._toBool(value)
            ? this._main.addEventListener('click', this._polygonClickHandler)
            : this._main.removeEventListener('click', this._polygonClickHandler)
    }

    get height() {
        return this._height;
    }

    set height(value) {
        this._height = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.height = this._setValueUnit(value);
            this._main.setAttribute("height", this._setValueUnit(value));
        }
    }

    get bordergeometry() {
        return this._d;
    }

    set bordergeometry(value) {
        if (this._isValidD(value)) {
            this._d = window._globalParams?.NormalizeGeometry ? "M0,0" + value : value;
            //this.afterInitialize();
            this._path.setAttribute("d", this._d);
            const size = this._path.getBBox();
            this._main.setAttribute(
                "viewBox",
                `${size.x} ${size.y} ${size.width || this.width} ${size.height || this.height
                }`
            );
            this._resource && (this.resource = this._resource);
        } else {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t("polygon_primitive_error"),
                text: String.format(i18next.t("polygon_cannot_set_value"), value, this.id),
            });
        }
    }

    _handlePolygonClick(x, y) {
        const point = this._path.ownerSVGElement.createSVGPoint();
        point.x = x;
        point.y = y;
        const matrix = this._path.getScreenCTM().inverse();
        const transformedPoint = point.matrixTransform(matrix);
        if (this._path.isPointInFill(transformedPoint) || this._path.isPointInStroke(transformedPoint)) {
            this.click();
        }
    }

    _handlePolygonContur(e) {
        e.stopPropagation();
        const { clientX: x, clientY: y } = e;
        document.elementsFromPoint(x, y).forEach(element => {
            if (element.nodeName === 'MS-POLYGON') {
                element._handlePolygonClick(x, y)
            }
        })
    }

    _handleMouseEnter() {
        this._path.style.stroke = this.tryToGetUserColor(this.bordercolorhover);
        this._path.style.strokeWidth = this._borderthicknesshover;
    }

    _handleMouseLeave() {
        this._path.style.stroke = '';
        this._path.style.strokeWidth = '';
    }


    /**
     * Проверка корректности пути для рисования
     * @param {string} value проверяемое значение
     * @return {bool} результат проверки
     */
    _isValidD(value) {
        const regEverythingAllowed = /[MmZzLlHhVvCcSsQqTtAaEe0-9-,.\s]/g;

        const containsIllegalCharacter = !!value.replace(
            regEverythingAllowed,
            ""
        ).length;
        const containsAdjacentLetters = /[a-zA-Z]{3}/.test(value);
        const invalidStart = /^[0-9-,.]/.test(value);
        const invalidEnd = /.*[-,.]$/.test(value.trim());

        return !(
            containsIllegalCharacter ||
            containsAdjacentLetters ||
            invalidStart ||
            invalidEnd
        );
    }
}